<template>
  <place-autocomplete
    v-model="value"
    :predictions="predictions"
    :is-invalid="isErrorVisible"
    :is-list-visible="isListVisible"
    @pick="handlePredictionPick"
    @add="handlePlaceAdd"
    @focus="handleFocus"
    @blur="handleBlur"
    @input="throttleAutocomplete"
  />
</template>

<script>
import throttle from 'lodash/throttle'
import uniqBy from 'lodash/uniqBy'
import isEmpty from 'lodash/isEmpty'
import { mapState, mapGetters, mapMutations } from 'vuex'

import { SET_PLACE_TITLE, SET_PLACE_ID } from '@/store/mutation-types'
import { MAP_CENTER } from '@/assets/js/map'
import PlaceAutocomplete from '@/components/PlaceAutocomplete'

export default {
  components: {
    PlaceAutocomplete
  },
  data () {
    return {
      value: '',
      predictions: [],
      isErrorVisible: false,
      throttleAutocomplete: throttle(this.fetchPredictions, 800)
    }
  },
  computed: {
    ...mapState({
      isValid: state => state.picker.isValid
    }),
    ...mapGetters({
      title: 'placeTitle'
    }),
    isListVisible () {
      return !this.isErrorVisible && !isEmpty(this.predictions) && !!this.value
    }
  },
  watch: {
    title () {
      this.mapTitle()
    },
    isValid () {
      this.isErrorVisible = !this.isValid
    }
  },
  created () {
    this.mapTitle()
  },
  methods: {
    ...mapMutations({
      setPlaceTitle: SET_PLACE_TITLE,
      setPlaceId: SET_PLACE_ID
    }),
    fetchPredictions () {
      if (!this.service) {
        this.service = new google.maps.places.AutocompleteService()
      }

      if (!this.value) return
      const req = {
        input: this.value,
        location: new google.maps.LatLng(MAP_CENTER),
        radius: 1800,
        language: 'pl',
        componentRestrictions: { country: 'pl' }
      }
      this.service.getPlacePredictions(req, res => {
        this.predictions = res
          ? uniqBy(res.filter(this.filterPrediction).slice(0, 4).map(this.createPrediction), 'title')
          : []
      })
    },
    mapTitle () {
      this.value = this.title
    },
    handleFocus () {
      this.isErrorVisible = false
    },
    handleBlur () {
      this.isErrorVisible = true
    },
    handlePredictionPick ({ placeId, title }) {
      this.predictions = []
      this.setPlaceId(placeId)
      this.setPlaceTitle(title)
    },
    handlePlaceAdd () {
      this.$emit('submit')
    },
    createPrediction (prediction) {
      return {
        placeId: prediction.place_id,
        title: prediction.structured_formatting.main_text
      }
    },
    filterPrediction (prediction = {}) {
      const hasWarsawInTerm = term => ['Warsaw', 'Warszawa'].includes(term.value)
      return prediction.terms && prediction.terms.some(hasWarsawInTerm)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/PlaceAutocompleteContainer.vue